import { Vision, VisionWrapper, VisionScenario, VisionCriteria, FreeDataCartesianBuilder } from '@wizeoo/akm-message-lib';
import { ALLKEY_COMMAND_METHOD } from '../../model/enums';
import { Model } from '../../model/model';
import { ExternalAPI } from '../../model/external-api';
import { ConnectVO } from '../../vo/core/connect.vo';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { VisionVO} from '@wizeoo/akm-compute-lib';

/**
 * Appels du service de génération de lignes de vision
 * Author LMA
 */
export class VisionManageLinesCmd extends WizCommand<Vision> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }
  
  public vo: VisionVO = null; // la vision porteuse des lignes à générer
  public steps: number[] = null; // les steps concernés
  public method: string = null; // la fonction à jouer

  public cnx:ConnectVO; // éventuelle fonction connect à l'origine de l'appel


  private do(vision: VisionVO, method: string, steps: number[] = null, callback: Function) {
    this.vo = vision;
    this.steps = steps;

    const wrapper: VisionWrapper = new VisionWrapper();
    wrapper.method = method;
    wrapper.scenario = new VisionScenario();
    wrapper.criteria = new VisionCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.criteria.stepLevels = this.steps;
    wrapper.entity = this.vo.source;
    this.configureRemote(ExternalAPI.VISION_MANAGELINE_LINES, wrapper, callback);
  }

  /** génération des lignes */
  public generate(vision: VisionVO, steps: number[] = null, callback: Function, cnx:ConnectVO = null): VisionManageLinesCmd {
    this.cnx = cnx;  
    this.do(vision, ALLKEY_COMMAND_METHOD.VISION_GENERATE_LINES, steps, callback);
    return this;
  }

  /** génération des nouvelles lignes */
  public generateNewLines(vision: VisionVO, steps: number[] = null, callback: Function, cnx:ConnectVO = null ): VisionManageLinesCmd {
    this.cnx = cnx;  
    this.do(vision, ALLKEY_COMMAND_METHOD.VISION_GENERATE_NEW_LINES, steps, callback);
    return this;
  }

  /** suppression des lignes */
  public deleteLines(vision: VisionVO, steps: number[] = null, callback: Function): VisionManageLinesCmd {
    this.do(vision, ALLKEY_COMMAND_METHOD.VISION_DELETE_LINES, steps, callback);
    return this;
  }

  /** suppression des values */
  public deleteValues(vision: VisionVO, steps: number[] = null, callback: Function): VisionManageLinesCmd {
    this.do(vision, ALLKEY_COMMAND_METHOD.VISION_DELETE_VALUES, steps, callback);
    return this;
  }

  /** génération des lignes */
  public cartesian(vision: VisionVO, steps: number[] = null, cartesian: FreeDataCartesianBuilder, callback: Function): VisionManageLinesCmd {
     
    this.do(vision, ALLKEY_COMMAND_METHOD.VISION_CARTESIAN, steps, callback);
    (this.context as VisionWrapper).criteria.cartesian = cartesian;
    return this;
  }

  /** Execution call */
  public async execute(): Promise<any> {
    super.execute();
  }

  /** sur retour, traitement selon la méthode */
  public wizResult() {
    // console.log('pack result');
    this.vo.source = this.result;
    // console.log('vision app ok');
    super.wizResult();
  }

}
